import { Cancel, Check, CheckCircle, ReportProblem, Verified } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Fragment } from "react/jsx-runtime";

export default function TransferContainer({ query, setCalendar }) {
  return query.isLoading ? (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 4, alignSelf: "center", color: "#444", flex: 1 }}>
      <CircularProgress />
    </Box>
  ) : query.isLoadingError ? (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 4, alignSelf: "center", color: "#444", flex: 1 }}>
      <Typography>Fehler</Typography>
    </Box>
  ) : (query?.data ?? []).length === 0 ? (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 4, alignSelf: "center", color: "#444", flex: 1 }}>
      <Typography>Keine Transfere an diesem Datum</Typography>
    </Box>
  ) : (
    (query?.data ?? [])
      .sort((a, b) => (a.date > b.date ? -1 : a.date < b.date ? 1 : 0))
      .map((x, i, f) => (
        <Fragment>
          {i === 0 || f[i - 1].date !== x.date ? (
            <Box
              sx={{
                position: "sticky",
                top: 0,
                color: "#555",
                p: "4px 6px",
                lineHeight: 1,
                fontWeight: "14px",
                mb: "8px",
                flexShrink: 0,
                background: "#edf0f9",
                borderTop: "1px solid rgba(0,0,0,0.2)",
                borderBottom: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "inset 0px -4px 5px rgba(0,0,0,0.1)",
              }}
            >
              {dayjs(x.date).format("DD.MM.YYYY")}
            </Box>
          ) : null}

          <Box
            key={x.transfer_id}
            sx={{
              cursor: "pointer",
              "&:hover": {
                opacity: 0.5,
              },
              display: "flex",
              flexDirection: "column",
              border: "1px solid #777",
              mb: "8px",
              "&:first-child": {
                mt: "8px",
              },
              mx: "4px",
              alignItems: "stretch",
              overflow: "hidden",
              borderRadius: "5px",
              flexShrink: 0,
              fontSize: "13px",
            }}
            onClick={() => setCalendar("KGP", x.resource_tag_id, dayjs(x.date, "YYYY-MM-DD"))}
          >
            <Box sx={{ display: "flex", borderBottom: "1px solid #777" }}>
              <Box
                sx={{
                  borderRight: "1px solid #aaa",
                  color: !x.active ? "#6c6c6cff" : !!x.was_guessed ? "#faac26ff" : "#666",
                  boxShadow: "inset -4px 0px 5px rgba(0,0,0,0.1)",
                  p: "4px 6px",
                  lineHeight: 1,
                  background: !x.active ? "#f0f0f0" : !!x.was_guessed ? "#ffe8c1ff" : "#edf0f9",
                }}
              >
                {!x.active ? <Cancel fontSize="small" /> : !!x.was_guessed ? <Verified fontSize="small" /> : <CheckCircle fontSize="small" />}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  p: "4px",
                  overflow: "hidden",
                  lineHeight: 1,
                  textOverflow: "ellipsis",
                }}
              >
                <span style={{ fontSize: "12px", marginRight: "2px" }}>{x.resource_number}</span>
                {x.resource_name}
              </Box>
            </Box>
            {x.original_type !== "" ? (
              <Box
                sx={{
                  lineHeight: 1,
                  borderBottom: "1px solid #aaa",
                  whiteSpace: "nowrap",
                  textDecoration: "line-through rgba(0,0,0,0.5)",
                  fontSize: "90%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  p: "2px",
                  backgroundColor: "#eee",
                }}
              >
                {x.original_type === "project" ? <span style={{ fontSize: "12px", marginRight: "2px" }}>{x.original_location_number}</span> : null}
                {x.original_location_name}
              </Box>
            ) : null}
            <Box
              sx={{
                lineHeight: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                p: "2px",
                backgroundColor: "#eee",
              }}
            >
              {x.type === "project" ? <span style={{ fontSize: "12px", marginRight: "2px" }}>{x.location_number}</span> : null}
              {x.location_name}
            </Box>
            {!!x.erfasser_name ? (
              <Box
                sx={{
                  display: "-webkit-box",
                  p: "2px",
                  pt: "3px",
                  borderTop: "1px solid #aaa",
                  "-webkit-line-clamp": "2",
                  "-webkit-box-orient": "vertical",
                  overflow: "hidden",
                  fontSize: "12px",
                  lineHeight: 1.1,
                  textAlign: "right",
                  backgroundColor: "#f7f7f7",
                  boxShadow: "0 2px 3px rgba(0,0,0,0.1) inset",
                  textOverflow: "ellipsis",
                }}
              >
                {x.erfasser_name}
              </Box>
            ) : null}
            {!!x.comment ? (
              <Box
                sx={{
                  display: "-webkit-box",
                  p: "2px",
                  pt: "3px",
                  borderTop: "1px solid #aaa",

                  overflow: "hidden",
                  fontSize: "12px",
                  lineHeight: 1.1,
                  textAlign: "right",
                  backgroundColor: "#f7f7f7",
                  boxShadow: "0 2px 3px rgba(0,0,0,0.1) inset",
                  textOverflow: "ellipsis",
                }}
              >
                {x.comment}
              </Box>
            ) : null}
          </Box>
        </Fragment>
      ))
  );
}
